let main = document.body;
let lastScrollY = window.scrollY;

window.onscroll = function() {scrollFunction()};

function scrollFunction() {
    const currentScrollY = window.scrollY;

    if (currentScrollY > 40) {
        main.classList.add('scroll');
    } else {
        main.classList.remove('scroll');
    }

    if (currentScrollY < lastScrollY) {
        main.classList.add('scroll-up');
    } else {
        main.classList.remove('scroll-up');
    }

    lastScrollY = currentScrollY;
}

// Set the correct initial state in case the page loads already scrolled
// (e.g. restored scroll position, or a fragment link).
scrollFunction();

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

    // Move keyboard focus back to the start of the page so tabbing
    // continues from main-content again, matching the scroll position.
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
        if (!mainContent.hasAttribute('tabindex')) {
            mainContent.setAttribute('tabindex', '-1');
        }
        mainContent.focus({ preventScroll: true });
    }
}
//# sourceMappingURL=back-to-top.js.map
